export const overallProgressV5Ashn = {
  new: "New",
  better: "Improving",
  stable: "Stable",
  stalled: "Stalled",
  worse: "Deteriorating",
  healed: "Resolved",
  monitoring: "Monitoring Post Closure",
  unknown: "Status Unknown"
};
